<template>
  <div :style="'min-width:' +  minWidth" :class="{'form-floating': !simple}">
    <v-select
        :taggable="taggable"
        :class="[background]"
        :disabled="disabled"
        :label="text" :code="code"
        :multiple="multiple"
        :placeholder="placeholder"
        :name="name"
        :filterable="false"
        :required="required"
        v-model="model" v-on="$listeners"
        @listener
        @open="onOpen"
        @close="onClose"
        @search="load"
        :options="list">
      <template #search="{attributes, events}">
        <input class="vs__search" :required="required && !model" v-bind="attributes" v-on="events"/>
      </template>
      <template #selected-option="option">
        <slot name="selected-option" :option="option"></slot>
      </template>
      <template #option="option">
        <slot name="option" :option="option"></slot>
      </template>
      <template #list-footer>
        <li v-show="hasNextPage" ref="load">
          <div class="text-center">
            <div class="spinner-border spinner-border-sm" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </li>
      </template>
    </v-select>
    <label v-if="!simple"> {{ label || trans('general.defaults.type_to_search') }}  <span v-if="required">*</span> </label>
    <!--  To support FormData load    -->
    <input type="hidden" :class="{'is-invalid': error}" :name="name" :required="required" :value="model ? model.value : ''">
    <small v-if="help" class="form-text text-muted m-sm-2">{{ help }}</small>
    <div class="invalid-feedback d-block" v-if="error">
      {{ error }}
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";

export default {
  name: "AutoloadSelect",
  props: {
    url: {
      type: String,
      required: true,
    },
    options: {
      type: Object | Array,
      required: false,
      default: () => {
        return []
      }
    },
    value: Object | String | Number,
    name: String,
    placeholder: {
      type: String,
      default: trans('general.defaults.type_to_search')
    },
    label: String,
    taggable: Boolean,
    multiple: {
      type: Boolean,
      default: false
    },
    code: {
      type: String,
      default: 'code'
    },
    text: {
      type: String,
      default: 'label'
    },
    background: {
      type: String,
      default: 'form-control'
    },
    help: {
      type: String,
      required: false,
    },
    simple: Boolean,
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    error: String,
    minWidth: {
      type: String,
      default: '200px'
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  watch: {
    model: function (val) {
      this.$emit('change', val)
      this.$emit('input', val)
    },
    value: function (val) {
      this.model = val;
    },
  },
  computed: {
    hasNextPage() {
      return this.page < this.lastPage;
    },
  },
  components: {
    vSelect
  },
  data() {
    return {
      observer: null,
      model: null,
      list: this.options,
      limit: 15,
      page: 1,
      lastPage: 1,
      q: '',
    }
  },
  methods: {
    load(search) {
      this.page = 1;
      this.list = []
      this.q = search;
      this.search(search, this)
    },
    search: _.debounce((search, vm) => {
      vm.loadData();
    }, 350),
    async onOpen() {
      if (this.hasNextPage) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose() {
      this.observer.disconnect()
    },
    async infiniteScroll([{isIntersecting, target}]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        this.nextPage()
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    nextPage: function () {
      if (this.page < this.lastPage) {
        this.page++;
        this.loadData();
      }
    },
    async loadData() {
      const {data} = await axios.get(this.url, {
        params: {
          limit: this.limit,
          page: this.page,
          search: this.q,
        }
      })
      this.lastPage = data.data.last_page ?? data.last_page;
      this.list = [...this.list, ...(data.data.data ?? data.data)];
    }
  },
  mounted() {
    if (this.value) {
      this.model = this.value;
    }
    this.observer = new IntersectionObserver(this.infiniteScroll)
    this.loadData();
  }
}
</script>
<style scoped>
.min-width {
    min-width: 200px;
  }
</style>